// extracted by mini-css-extract-plugin
export var actionButton = "_kl-t";
export var buttonContainer = "_kl-0";
export var buttonContainer2 = "_kl-1";
export var buttonSection = "_kl-2";
export var details = "_kl-3";
export var dropdownItem = "_kl-5";
export var dropdownItemsContainer = "_kl-4";
export var fileInput = "_kl-r";
export var headerButton = "_kl-6";
export var icon = "_kl-7";
export var input = "_kl-8";
export var macroListItem = "_kl-9";
export var mainContent = "_kl-a";
export var microText = "_kl-b";
export var modal = "_kl-w";
export var optionsButton = "_kl-c";
export var paperclip = "_kl-s";
export var pillContent = "_kl-d";
export var preview = "_kl-e";
export var preview2 = "_kl-f";
export var quillEditor = "_kl-q";
export var selectedMacro = "_kl-g";
export var sidebar = "_kl-h";
export var sidebarHeader = "_kl-j";
export var sidebarList = "_kl-i";
export var sidebarListItem = "_kl-k";
export var sidebarSearch = "_kl-l";
export var snoozeDurationWrapper = "_kl-v";
export var statusPillContainer = "_kl-m";
export var tagsContainer = "_kl-n";
export var unselectedMacro = "_kl-o";
export var variable = "_kl-u";
export var wrapper = "_kl-p";